import { useState, type KeyboardEvent } from 'react';

interface Props {
  value: string[];
  onChange: (next: string[]) => void;
  placeholder?: string;
}

export const DomainsEditor = ({ value, onChange, placeholder }: Props) => {
  const [input, setInput] = useState('');

  const add = () => {
    const next = input.trim().toLowerCase().replace(/^https?:\/\//, '').replace(/\/.*$/, '');
    if (!next) return;
    if (value.includes(next)) {
      setInput('');
      return;
    }
    onChange([...value, next]);
    setInput('');
  };

  const remove = (host: string) => onChange(value.filter((d) => d !== host));

  const handleKey = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || e.key === ',' || e.key === ' ') {
      e.preventDefault();
      add();
    } else if (e.key === 'Backspace' && input === '' && value.length > 0) {
      onChange(value.slice(0, -1));
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-1.5 border border-line rounded-md px-2 py-1.5 bg-white">
      {value.map((host) => (
        <span
          key={host}
          className="inline-flex items-center gap-1 rounded-md bg-brand-light text-brand-dark px-2 py-0.5 text-xs"
        >
          {host}
          <button
            type="button"
            onClick={() => remove(host)}
            className="text-brand-dark/60 hover:text-brand-dark"
            aria-label={`Remove ${host}`}
          >
            ×
          </button>
        </span>
      ))}
      <input
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={handleKey}
        onBlur={add}
        placeholder={value.length === 0 ? (placeholder ?? 'example.com') : ''}
        className="flex-1 min-w-[120px] outline-none text-sm bg-transparent py-0.5"
      />
    </div>
  );
};
